import { ApiPromise } from '@polkadot/api';
import { ContractPromise } from '@polkadot/api-contract';

import { displayErrorToast } from 'components/NotificationToast';

import { ErrorToastMessages, readOnlyGasLimit } from 'shared/constants';

import psp34StandardMetadata from '../metadata/metadata_psp34_standard.json';
import addresses from '../metadata/addresses.json';
import { getDataFromOutput } from './getDataFromOutput';

export const getNftBalanceOfOwner = async (
  api: ApiPromise,
  ownerAddress: string,
): Promise<string | null> => {
  let data = null;
  const gasLimit = readOnlyGasLimit(api);

  const contract = new ContractPromise(api, psp34StandardMetadata, addresses.pmp_psp34_address);

  const { result, output } = await contract.query['psp34::balanceOf'](
    contract.address,
    {
      gasLimit,
      value: 0,
    },
    ownerAddress,
  );

  if (result.isOk && output) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    data = getDataFromOutput<string>(output.toHuman()).replaceAll(',', '') as number;
  }

  if (result.isErr) {
    console.log(result.toHuman());
    displayErrorToast(ErrorToastMessages.ERROR_FETCHING_DATA);
  }
  return data;
};
